import { createClient } from "@supabase/supabase-js";

// ── Supabase client ──────────────────────────────────────────────────
// Per-environment Supabase project. test.netrev.ai -> the TEST project; every
// other host (prod domain / raw IP / localhost) -> PRODUCTION. Mirrors the
// API_BASE hostname pattern in App.js. Both keys are PUBLISHABLE (public), so it
// is safe to ship both in the bundle; the host decides which one is used.
const __isTestEnv = typeof window !== "undefined" && window.location.hostname === "test.netrev.ai";
const SUPABASE_URL = __isTestEnv
  ? "https://cxmemqojmewovvuligvz.supabase.co"
  : "https://zslfeetmshtqndcjcbbr.supabase.co";
const SUPABASE_KEY = __isTestEnv
  ? "sb_publishable_38QkvJeLhQ4OTX-pgmPBAQ_CEKkb5gm"
  : "sb_publishable_oRA3XEtjBY3-2iT4Ne8I5Q_UtX0-Zq5";

// ── Password-recovery URL detection ──────────────────────────────────
// MUST run before createClient(). detectSessionInUrl (Supabase default) eats
// the URL hash during async SDK init — by the time React mounts the hash is
// already gone. We snapshot synchronously and latch the result into
// sessionStorage so any later re-render / rerun still sees it.
// Covers: implicit flow (#access_token + type=recovery), PKCE (?code=) when
// landing on /reset-password, and the path itself as the strongest signal.
const __initialUrlHash   = typeof window !== "undefined" ? (window.location.hash   || "") : "";
const __initialUrlSearch = typeof window !== "undefined" ? (window.location.search || "") : "";
const __initialUrlPath   = typeof window !== "undefined" ? (window.location.pathname || "") : "";
const __pathLooksRecovery = __initialUrlPath === "/reset-password" || __initialUrlPath.startsWith("/reset-password/");
const __hashHasRecovery   = __initialUrlHash.includes("type=recovery") && __initialUrlHash.includes("access_token");
const __searchHasRecovery = __initialUrlSearch.includes("type=recovery");
const __hasPkceCodeOnRecoveryPath = __pathLooksRecovery && /[?&]code=/.test(__initialUrlSearch);
export const __DETECTED_RECOVERY = __pathLooksRecovery || __hashHasRecovery || __searchHasRecovery || __hasPkceCodeOnRecoveryPath;
if (typeof window !== "undefined" && __DETECTED_RECOVERY) {
  try { sessionStorage.setItem("__netrev_recovery", "1"); } catch (_) {}
  // Visible marker so you can verify in devtools that the new bundle is running.
  // Look for this line in the browser console after clicking the email link.
  // eslint-disable-next-line no-console
  console.log("[netrev] Password recovery flow detected at module init", {
    path: __initialUrlPath, hashHasRecovery: __hashHasRecovery, searchHasRecovery: __searchHasRecovery, pkce: __hasPkceCodeOnRecoveryPath,
  });
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
